<template>
  <v-card>
    <v-card-title>
      {{ $t("Top.todos") }}
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list nav dense>
        <v-list-group color="sidebarActive" class="mb-1">
          <template v-slot:activator>
            <v-list-item-content class="me-n16">
              <v-list-item-title class="me-n16">
                <v-row no-gutters>
                  <v-col>
                    {{ $t("Order.ObjectName") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-16">{{
                    todos ? todos.order_count : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/orders');
                    })
                  "
                >
                  <v-col>
                    {{ $t("Order.status.new") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.order ? todos.order.wait_confirm_count : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/orders-approve');
                    })
                  "
                >
                  <v-col>
                    {{ $t("Order.status.confirmed") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.order ? todos.order.wait_approve_count : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/stock-orders-out');
                    })
                  "
                >
                  <v-col>
                    {{ $t("Order.status.granted") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.order ? todos.order.wait_out_count : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/distributions');
                    })
                  "
                >
                  <v-col>
                    {{ $t("Order.status.out_stock") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.order
                      ? todos.order.wait_distribute_count
                      : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group color="sidebarActive" class="mb-1">
          <template v-slot:activator>
            <v-list-item-content class="me-n16">
              <v-list-item-title class="me-n16">
                <v-row no-gutters>
                  <v-col>
                    {{ $t("ReturnOrder.ObjectName") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-16">{{
                    todos ? todos.return_count : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/return-orders');
                    })
                  "
                >
                  <v-col>
                    {{ $t("ReturnOrder.status.new") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.return_order
                      ? todos.return_order.wait_confirm_count
                      : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/return-orders-approve');
                    })
                  "
                >
                  <v-col>
                    {{ $t("ReturnOrder.status.confirmed") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.return_order
                      ? todos.return_order.wait_approve_count
                      : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item color="sidebarActive" :href="'/#'" link>
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row
                  no-gutters
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('/stock-orders-in');
                    })
                  "
                >
                  <v-col>
                    {{ $t("ReturnOrder.status.granted") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    todos && todos.return_order
                      ? todos.return_order.wait_in_count
                      : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ToDos",

  props: {
    todos: Object,
  },
};
</script>
